import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { Text } from "./components"

const ProductDetails = ({ details, productTitle }) => (
  <Box>
    <Typography fontSize="24px" lineHeight="28px" mb="12px">
      {productTitle}
    </Typography>
    <Box mb={3}>
      {details &&
        details.map((detail) => <Text key={`pdetail${detail}`}>{detail}</Text>)}
    </Box>
  </Box>
)

ProductDetails.propTypes = {
  details: PropTypes.array,
  productTitle: PropTypes.string,
}

export default ProductDetails
